<style>
.consultation-popover {
    width: 40vw; /* or any fixed width like 400px */
    max-width: 90vw;
}
</style>
<template>
    <!-- <b-navbar class="consult-nav breadcrumb" toggleable type="light" variant="light"> -->
    <b-navbar id="schedule-navbar" class="justify-content-center border-top border-primary" type="light" variant="light">
        <b-navbar-nav>
            <span
                id="popover-consultation"
                @click="popoverShow = true"
                class="text-truncate align-middle plain-text-underline"
                style="max-width: 60vw;">
                <small>
                    <i class="d-md-down-none text-muted fa-regular fa-calendar-check mr-2"></i> {{  consultation?.rfe }} {{ consultation?.insurance_info ? `(${consultation?.insurance_info})` : '(No insurance selected)' }}
                </small>
            </span>
            <b-popover
                target="popover-consultation"
                triggers="click"
                :show.sync="popoverShow"
                placement="bottom"
                container="schedule-navbar"
                ref="popover"
                custom-class="consultation-popover">
                    <template #title>
                        <b-button @click="popoverShow = false" class="close" aria-label="Close">
                            <span class="d-inline-block" aria-hidden="true">&times;</span>
                        </b-button>
                        Consultation
                    </template>
                
                    <ConsultationForm @saved="popoverShow = false" />
                    </validation-observer>
            </b-popover>
        </b-navbar-nav>
    </b-navbar>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapActions } from "vuex"
import ConsultationForm from "@/core/components/patients/consultations/ConsultationForm"

export default FormExtension.extend({
	name: 'schedule-consultation',
    components: {
        ConsultationForm
    },
	data () {
		return {
            popoverShow: false
		}
	},
    computed: {
        ...mapGetters('schedule', ['getCurrentConsultation']),
        consultation() {
            return this.getCurrentConsultation()
        }
	}
})

</script>